import { styled } from '@mui/material';

export const MainMenuListContainer = styled('ul')({
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
  listStyleType: 'none',
});
